import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelChoiceTitle = styled.span`
  color: white;
  font-size: ${32 * Screen.widthRatio}px;
  text-align: center;
  font-family: ${Fonts['regular']};
`;

export default ChannelChoiceTitle;
